import React from 'react';

import { Button } from '@ast/magma/components/button';
import { Checkbox } from '@ast/magma/components/checkbox';

import styles from './TermsControl.pcss';

export interface TermsControlLabels {
  readonly checkboxLabelText: string;
  readonly termsAndConditionsButtonText: string;
}

export interface TermsControlProps {
  readonly labels: TermsControlLabels;
  readonly termsAccepted: boolean;
  readonly showTerms: () => void;
  readonly onTermsAcceptedChange: (termsAccepted: boolean) => void;
}

export const TermsControl = React.forwardRef(({
  labels,
  termsAccepted,
  onTermsAcceptedChange,
  showTerms,
}: TermsControlProps,
ref: React.Ref<HTMLInputElement>) => {
  const handleTermsAcceptedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onTermsAcceptedChange(event.target.checked);
  };

  return (
    <div className={styles.termsWrapper}>
      <Checkbox
        data-stable-name="TermsCheckbox"
        label={labels.checkboxLabelText}
        checked={termsAccepted}
        ref={ref}
        onChange={handleTermsAcceptedChange}
      />
      <Button
        className={styles.termsButton}
        data-stable-name="TermsButton"
        look="link"
        onClick={showTerms}
      >
        {labels.termsAndConditionsButtonText}
      </Button>
    </div>
  );
});
